import CaptureOrEditHighlightController from './modal-capture-highlight-recorded';
import DownloadOrExportHighlightController from './modal-download-or-export-highlight';
import HighlightPreviewController from './modal-highlight-preview';

export default class HighlightsController {
  constructor($state, Broadcast, Highlight, ConfirmDialog, $rootScope, $uibModal, toaster) {
    'ngInject';
    this.$state = $state;
    this.$uibModal = $uibModal;
    this.toaster = toaster;
    this.Highlight = Highlight;
    this.ConfirmDialog = ConfirmDialog;
    this.user = $rootScope.user;

    this.HIGHLIGHTS_PAGE_SIZE = 10;

    this.maxMonetizedHighlightTimeS = MAX_MONETIZED_HIGHLIGHT_TIME_S;
    this.broadcastIsMonetized = false;
    this.broadcast = Broadcast.get({ id: $state.params.id }, (b) => {
      this.broadcastIsMonetized = !b.is_private && b.is_ticketed;
    });
    this.loadHighlightsForPage(1);

    this.loadingPromises = [this.broadcast.$promise, this.highlights.$promise];
  }

  get canDownloadOrExport() {
    const { user } = this;

    // If the user is not capable of creating any download or export, then don't show it
    if (
      user.cannot('create', 'highlight/*:download') &&
      user.cannot('create', 'highlight/*:kaltura-export') &&
      user.cannot('create', 'highlight/*:vimeo-export') &&
      user.cannot('create', 'highlight/*:youtube-export')
    ) {
      return false;
    }

    // If there's no transcoded recording, then don't show it.
    if (!this.recordingIsTranscoded) {
      return false;
    }

    return true;
  }

  get recordingIsTranscoded() {
    if (!this.broadcast) {
      return false;
    } else if (this.broadcast.recording_id && this.broadcast.recording_duration_seconds) {
      return true;
    } else {
      return false;
    }
  }

  showCaptureModal(highlight) {
    const { $uibModal, Highlight } = this;

    $uibModal.open({
      size: 'lg',
      backdrop: 'static', // don't allow accidental clicks on backdrop to close
      template: require('./modal-capture-highlight-recorded.html'),
      controllerAs: 'vm',
      controller: CaptureOrEditHighlightController,
      resolve: {
        highlightObj: () => highlight,
        recordingId: () => this.broadcast.recording_id,
      },
    });
  }

  showHighlight(highlight) {
    if (!this.broadcastIsMonetized || highlight.duration <= this.maxMonetizedHighlightTimeS) {
      this.playHighlight(highlight);
    } else {
      this.showCaptureModal(highlight);
    }
  }

  playHighlight(highlight) {
    const { $uibModal, $timeout, Highlight } = this;

    $uibModal.open({
      template: require('./modal-highlight-preview.html'),
      resolve: {
        broadcast: () => this.broadcast,
        highlightDetails: () => highlight,
        showSave: () => false,
      },
      controller: HighlightPreviewController,
      controllerAs: 'vm',
    });
  }

  delete(highlight) {
    const { Highlight, ConfirmDialog, $state } = this;

    let modalOptions = {
      closeButtonText: 'Cancel',
      actionButtonText: 'Delete Highlight',
      actionButtonClass: 'danger',
      headerText: 'Please Confirm',
      bodyText: 'Are you sure you want to permanently delete this highlight?',
    };

    ConfirmDialog.show(modalOptions).then(() => {
      Highlight.delete(
        { id: highlight.id, broadcastId: this.broadcast.id },
        () => {
          this.toaster.pop('warning', 'Successfully deleted highlight');
          this.highlights = Highlight.query({ broadcastId: this.broadcast.id });
        },
        () => alert('Error deleting highlight. Please reload this page and try again.')
      );
    });
  }

  download(highlight) {
    this.$uibModal.open({
      template: require('./modal-download-or-export-highlight.html'),
      controllerAs: 'vm',
      controller: DownloadOrExportHighlightController,
      resolve: {
        broadcast: () => this.broadcast,
        highlight: () => highlight,
      },
    });
  }

  loadHighlightsForPage(p) {
    this.highlights = this.Highlight.query(
      {
        broadcastId: this.$state.params.id,
        p: p - 1,
        l: this.HIGHLIGHTS_PAGE_SIZE,
        s: 'streamed_at',
      },
      (data, headers) => {
        var pagination = JSON.parse(headers('x-pagination'));
        this.highlightsPagination = {
          current: p,
          total: pagination.total,
          resultMin: this.HIGHLIGHTS_PAGE_SIZE * (p - 1) + 1,
          resultMax: this.HIGHLIGHTS_PAGE_SIZE * (p - 1) + data.length,
        };
      },
      (err) => {
        console.log(err);
        this.toaster.pop('warning', 'Unable to load highlights.');
      }
    );
  }
}



// WEBPACK FOOTER //
// ./app/pages/events/highlights.js